<template lang="pug">

div

  section
    AppTitle.u-mb-md(:title="$t('mantra')")


    div(v-if="$i18n.locale === 'en'")
      Content.is-normal

        h2 We take personal data protection seriously
        p During our recruitment process, we commit to protecting our candidates’ personal data they provide us with during the application or process. This policy describes how we collect the data and use it in the recruitment process.

        h2 Who will be collecting personal data
        p Baianat talent management department is responsible of collecting all the personal data during the process.

        h2 Personal data we collect
        p During the application process you will be asked to provide the following information:

        ul
          li Your name, address, email address, phone number(s) and other contact information.
          li Education history, work experience, CV, resume and cover letters.
          li Details about how you heard about us.
          li Details of the role you you’re applying for, e.g: expected salary, working hours..etc.
          li We will be asking you if you have any other commitments or signed any contracts with other parties but Baianat.
        p The collected information during the application screening phase is for pre-employment and background checks. The content and process of the background checks will vary from country to country according to laws.
        p In-depth information about candidates such as (Criminal records, Address History, ..etc.) Will be collected only after the group assessment stage, and prior to the TM and Lead interview. A reminder will be sent to the candidates with their prior consent of collecting this information in addition to more information about the nature of the pre-employment verification checks.
        p During the recruitment process, the following data maybe be collected as well:
        ul
          li Cover letter and personal statement.
          li Any interviewer notes collected from an interaction with you.
          li Any information you give to us.

        h2 Why we process your personal data
        p The information will be collected after you submit a request to join Baianat team is used to access your skills, conduct pre-employment checks, communicate with you through the process, complete the selection process, conduct surveys and researches to improve our recruitment process.
        p If your application is not successful, Baianat may use your contact information to notify you about different positions which may become available in the future.
        p By submitting your application, you authorize Baianat to store your information into the applicant tracking system. We will not share your personal information with any third parties. If you passed the recruitment process and joined Baianat team, all the data collected will be used to create your profile and stored into your records.
        p In case you were rejected, Baianat will erase all the personal data stored about you from the applicant tracking system.
        p You have the right to request access to your personal data, as well as the right to have your personal data erased, and the right to restrict or object to certain data processing activities. If you don't want us to retain your information, please notify us via #[a.button-link.is-small(href="mailto:privacy@baianat.com") privacy@baianat.com.]

        p Your information will be accessed only by Baianat talent management team, potential leads, our trusted hiring agencies and the associated technical staff, as relevant and necessary for your application.
        p Your information will be accessed by government officials where legal reporting requirements may exist, local labor authorities, courts, and tribunals, regulatory bodies or law enforcement agencies or private litigants.
        h2 Questions and complaints:
        p In case you consider that the processing of your personal data infringes the applicable data protection laws, you have the right to file a complaint to #[a.button-link.is-small(href="mailto:privacy@baianat.com") privacy@baianat.com.]
    div(v-else)
      Content.is-normal
        h2 نأخذ حماية بياناتك الشخصية على محمل الجد.
        p خلال عملية التوظيف لدينا، نلتزم بحماية البيانات الشخصية لجميع المتقدمين الذين يزودونا بها خلال الاستمارة أو عبر عمليات التوظيف. تصف هذه السياسة كيف نجمع البيانات ونستخدمها في عملية التوظيف.
        h2 مْن الذي سيجمع البيانات الشخصية.
        p يتحمل قسم إدارة المواهب في بيانات مسؤولية جمع البيانات الشخصية خلال مراحل عملية التوظيف.
        h2 البيانات الشخصية التي نجمعها.
        p أثناء عملية تقديم الطلب، سيُطلب منك البيانات التالية:
        ul
          li  اسمك وعنوانك وعنوان بريدك الإلكتروني ورقم هاتفك (أرقامك) ومعلومات الاتصال الأخرى.
          li  تاريخ التعليم والخبرة العملية و السيرة الذاتية وخطابات التغطية.
          li  تفاصيل حول كيف سمعت عنا.
          li  تفاصيل الوظيفة التي تتقدم إليها، على سبيل المثال، الراتب المتوقع وعدد ساعات العمل ….إلخ.
          li  سنسألك إذا كان لديك أي التزامات أخرى أو وقعت على أي عقود مع أطراف أخرى بخلاف بيانات.
        p المعلومات التي يتم جمعها خلال مرحلة فحص الاستمارة وعمليات التوظيف هي للفحص ما قبل التوظيف ومعرفة خلفية بسيطة عنك. يختلف محتوى وعمليات الفحص من دولة إلى أخرى وفقًا للقوانين.
        p سيتم جمع المعلومات بتعمق شديد حول المرشحين مثل (السجلات الجنائية، سجل العناوين، ..الخ) فقط بعد مرحلة تقييم المجموعة، وقبل مقابلة قسم إدارة المواهب. سيتم إرسال تذكير إلى المرشحين بموافقتهم المسبقة على جمع هذه المعلومات بالإضافة إلى مزيد من المعلومات حول طبيعة فحوصات التحقق السابقة للتوظيف.
        p خلال عملية التوظيف، سيتم جمع البيانات التالية أيضًا:
        ul
          li  خطاب تغطية وبيان شخصي.
          li  أي ملاحظات يتم جمعها عند التفاعل معك أثناء المقابلة.
          li  أي معلومات تعطيها لنا.
        h2 لماذا نعالج بياناتك الشخصية.
        p  سيتم جمع البيانات بعد تقديم طلب الانضمام إلى فريق بيانات ويستخدم للوصول إلى مهاراتك، وإجراء فحوصات ما قبل التوظيف، والتواصل معك خلال مراحل التوظيف، واستكمال عملية الاختيار، وإجراء الدراسات الاستقصائية والأبحاث لتطوير عملية التوظيف لدينا.
        p  إذا لم تنجح في طلبك، فمن الممكن أن نستخدم بيانات الاتصال بك لإخبارك بأي وظائف مختلفة قد تكون متاحة في المستقبل.
        p  بإرسال طلبك، فأنت تمنح بيانات التفويض بتخزين بياناتك في نظام تتبع مُقدم الطلب. لن نشارك بياناتك الشخصية مع أي أطراف ثالثة. إذا نجحت في مراحل التوظيف وانضممت إلى فريق بيانات، سيتم استخدام جميع البيانات التي تم جمعها لإنشاء ملفك الشخصي وتخزينها في سجلاتك.
        p  في حال تم رفضك، سنقوم بمحو جميع البيانات الشخصية المخزنة في نظام تتبع مُقدم الطلب.
        p  لديك الحق في طلب الوصول إلى بياناتك الشخصية، وكذلك الحق في مسح بياناتك الشخصية، والحق في تقييد أو الاعتراض على أنشطة معالجة بيانات معينة. إذا كنت لا تريد منا الاحتفاظ بمعلوماتك، يرجى إبلاغنا عبر #[a.button-link.is-small(href="mailto:privacy@baianat.com") privacy@baianat.com.]
        p  لن يتم الوصول إلى معلوماتك إلا من خلال فريق إدارة المواهب الخاص ببيانات، والاكتشافين المحتملين، ووكالات التوظيف الموثوقة والموظفين الفنيين المرتبطين بها، حسب الاقتضاء والضرورية لطلبك.
        p  سيتم الوصول إلى معلوماتك من قبل المسؤولين الحكوميين حيث قد تكون هناك متطلبات إبلاغ قانونية، أو سلطات العمل المحلية، أو المحاكم، أو الهيئات القضائية، أو الهيئات التنظيمية، أو وكالات تنفيذ القانون أو المتقاضين الخاصين.
        h2 الأسئلة والشكاوي:
        p إذا كنت تعتقد أن معالجة بياناتك الشخصية تنتهك قوانين حماية البيانات المعمول بها، فيحق لك تقديم شكوى إلى #[a.button-link.is-small(href="mailto:privacy@baianat.com") privacy@baianat.com.]


</template>

<script>
import Content from '@/components/Content';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Content
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Recruitment privacy policy",
    "pageDesc":"Our recruitment policy describes our selection standards and how we collect the candidates data and use it in our processes.",
    "mantra":"Recruitment |privacy |policy"
  },
  "ar": {
    "pageTitle":"سياسة الخصوصية للتوظيف.",
    "pageDesc":"تصف هذه السياسة طريقة جمع البيانات واستخدامها في عملية اختيار المرشح المناسب وكيفية حماية البيانات الشخصية المقدمة لنا. ",
    "mantra":"سياسة |خصوصية |التوظيف. "
  }
}
</i18n>
